import React, { useEffect, useState } from "react";
import DropdownUser from "./ui/DropdownUser.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useTicketContext } from "../context/TicketContext.js";
import { UserAuth } from "../context/AuthContext.js";
import Button from "./ui/Button.js";

const Navbar = ({ getTask, showSearchInput }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { getTickets } = useTicketContext();
  const { user } = UserAuth();
  const [textBoxValue, setTextBoxValue] = useState("");

  const handleReviewInvoice = async () => {
    try {
      // here need to check if we have getTask function then call this function
      if (getTask) {
        await getTask(textBoxValue);
        setTextBoxValue("");
      } else {
        await getTickets(textBoxValue);
      }
    } catch (error) {
      console.log("### something went wrong ###");
    }
  };

  return (
    <div className="flex bg-dark-blue-2 px-10 items-center justify-between h-78">
      <div className=" flex items-center gap-48">
        <img
          onClick={() => navigate("/")}
          src="/sps-2.svg"
          className="w-43 h-41"
          alt="sps-logo"
        />
{
  /* 
  {user?.isAdmin && pathname !== "/" && (
    <Button
      className="border-none w-93 h-44 rounded-[40px] font-16-21-400 bg-linearGradient text-white"
      path="/admin/users"
    >
      Admin
    </Button>
  )} 
  */
}

      </div>

      <div className="flex items-center gap-48">
        {showSearchInput && (
          <div className="border br-8 w-381 bg-white h-39 flex items-center justify-between">
            <input
              type="text"
              className="h-35 px-2 w-full font-12-14-400 flex border-none"
              placeholder="click here to search..."
              value={textBoxValue}
              onChange={(e) => setTextBoxValue(e.target.value)}
            />

            <button
              className="h-35 br-6 border-none text-center font-14-16-400 min-w-81 bg-linearGradient-2 text-white"
              onClick={handleReviewInvoice}
            >
              Search
            </button>
          </div>
        )}
        <DropdownUser shouldDisplayEmail={false} isDarkTheme />
      </div>
    </div>
  );
};

export default Navbar;
